import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { setRehashFlag } from "@containers/App/ABExperimentReducer/reducer.js"
import { parseReverseGeoData, parseUpdateAddressData, parseAddressData, parsePopupdata } from "./parser"
import { keysToCamel } from "@lib/snakeTocamel"
const initialState = {
    isLoading: false,
    error: null,
    data: {},
    pincode: {},
    addressSelectionLoading: false,
    removeAddressError: false,
    serviceabilityData: {
        data: null,
        isFetching: false,
        isFetched: false,
        error: null,
    },
}

export const corporateLabsAddressPageSlice = createSlice({
    name: "addressFlowReducer",
    initialState: initialState,
    reducers: {
        setAddressSelectionLoading: (state, action) => {
            state.addressSelectionLoading = action.payload
        },
        setReverseGeoCodeData: (state, action) => {
            state.data.reverseGeoData = parseReverseGeoData(action?.payload)
        },
        setAddressInfo: (state, action) => {
            state.data.reverseGeoData = parseReverseGeoData(action?.payload)
            state.data.addressSelectionLoading = false
            state.data.addressSelectionError = false
        },
    },
    extraReducers: (builder) => {
        //handle asynchronous actions
        // Fetch Address actions
        builder.addCase(fetchAddressData.fulfilled, (state, action) => {
            const parsedData = parseAddressData(action?.payload?.widgets)
            state.data = parsedData
            state.isLoading = false
            state.error = null
        }),
            builder.addCase(fetchAddressData.pending, (state) => {
                state.isLoading = true
            }),
            builder.addCase(fetchAddressData.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
                state.data = null
            })
        builder.addCase(fetchMoreAddressData.fulfilled, (state, action) => {
            state.isFetchedMore = true
            state.isFetchingMore = false
            state.isFetchMoreError = false
            const parsedData = parseAddressData(
                action?.payload?.response?.widgets,
                action?.payload?.pageNumber,
                state.data.totalNumberOfAddress,
                action?.payload?.existingAddress,
                action?.payload?.addressCta,
                action?.payload?.addressIdSelected
            )
            state.data = parsedData
            state.data.updateAddressDialogBox = parseUpdateAddressData(
                action?.payload?.update_address_dialog_data
            )
        }),
            builder.addCase(fetchMoreAddressData.pending, (state) => {
                state.isFetchedMore = false
                state.isFetchingMore = true
                state.isFetchMoreError = false
                state.error = false
            }),
            builder.addCase(fetchMoreAddressData.rejected, (state) => {
                state.isFetchedMore = false
                state.isFetchingMore = false
                state.isFetchMoreError = true
                state.error = true
            })
        builder.addCase(getSearchedAddress.fulfilled, (state, action) => {
            state.data.reverseGeoData = parseReverseGeoData(action?.payload)
            state.data.addressSelectionLoading = false
            state.data.addressSelectionError = false
        })
        builder.addCase(getSearchedAddress.pending, (state) => {
            state.data.addressSelectionLoading = true
            state.data.addressSelectionError = false
        })
        builder.addCase(getSearchedAddress.rejected, (state) => {
            state.data.reverseGeoData = {}
            state.data.addressSelectionLoading = false
            state.data.addressSelectionError = true
        })
        builder.addCase(removeAddress.rejected, (state) => {
            state.removeAddressError = true
        })
        // Fetch Pincode details
        builder.addCase(fetchPinCodeDetails.fulfilled, (state, action) => {
            state.pincode.isLoading = false
            state.pincode.error = false
            state.pincode.data = {
                id: action?.payload?.id,
                city: action?.payload?.city,
                state: action?.payload?.state,
            }
        }),
            builder.addCase(fetchPinCodeDetails.pending, (state) => {
                state.pincode.isLoading = true
                state.pincode.data = null
                state.pincode.error = false
            }),
            builder.addCase(fetchPinCodeDetails.rejected, (state) => {
                state.pincode.isLoading = false
                state.pincode.data = null
                state.pincode.error = true
            })
        builder.addCase(getServiceabilityData.fulfilled, (state, action) => {
            state.serviceabilityData.isFetching = false
            state.serviceabilityData.isFetched = true
            state.serviceabilityData.data = {
                image: {
                    ...action.payload.popups?.service_unavailable?.image,
                    height: "96px",
                    width: "96px",
                },
                header: action.payload.popups?.service_unavailable?.header,
                description: action.payload.popups?.service_unavailable?.description,
                cta: keysToCamel(action.payload.popups?.service_unavailable?.cta),
                gaDetails: action.payload.popups?.service_unavailable?.gaDetails,
            }
        }),
            builder.addCase(getServiceabilityData.pending, (state) => {
                state.serviceabilityData.isFetching = true
                state.serviceabilityData.isFetched = false
            }),
            builder.addCase(getServiceabilityData.rejected, (state, action) => {
                state.serviceabilityData.isFetching = false
                state.serviceabilityData.isFetching = true
                state.serviceabilityData.error = action.payload
            })
        builder.addCase(addAddress.rejected, (state, action) => {
            if (action.payload?.is_serviceable === false) {
                const { errorCallback } = action.meta.arg
                state.serviceabilityData.data = parsePopupdata(action.payload)
                errorCallback(action.payload)
            }
        })
        builder.addCase(editAddress.rejected, (state, action) => {
            if (action.payload?.is_serviceable === false) {
                const { errorCallback } = action.meta.arg
                state.serviceabilityData.data = parsePopupdata(action.payload)
                errorCallback(action.payload)
            }
        })
    },
})
/**
 * @description api call for rbf fetch address
 */
export const fetchAddressData = createAsyncThunk(
    "addressFlowData/fetchAddress",
    async (_arg, { extra, dispatch, getState }) => {
        const { api } = extra
        const { corporateDetails } = getState().shellReducer
        const { currentCity } = getState().locationsReducer
        const corporate_name = corporateDetails?._source
        try {
            const res = await api.get(
                `api/rbf/user/address?page_size=10&page_number=0&city=${currentCity}&corporate_name=${corporate_name}`
            )
            // setting rehash flag based on the response
            dispatch(setRehashFlag(res?.data?.rehash_data?.is_enabled))
            return Promise.resolve(res.data)
        } catch (err) {
            return Promise.resolve(err)
        }
    }
)
/**
 * @description fetch mpre rbf address
 * @param pageNumber
 * @param existingAddress
 * @param addressCta
 * @param selectedAddressId
 */
export const fetchMoreAddressData = createAsyncThunk(
    "addressFlowData/fetchMoreAddressPageData",
    async (_arg, { extra, rejectWithValue, dispatch, getState }) => {
        const { api } = extra
        const { pageNumber, existingAddress, addressCta, selectedAddressId } = _arg
        const { corporateDetails } = getState().shellReducer
        const { currentCity } = getState().locationsReducer
        const corporate_name = corporateDetails?._source
        try {
            const res = await api.get(
                `api/rbf/user/address?page_number=${pageNumber}&page_size=10&&city=${currentCity}&corporate_name=${corporate_name}`
            )
            dispatch(setRehashFlag(res?.data?.rehash_data?.is_enabled))
            return Promise.resolve({
                response: res.data,
                pageNumber: pageNumber,
                existingAddress: existingAddress,
                addressCta: addressCta,
                addressIdSelected: selectedAddressId,
            })
        } catch (err) {
            return rejectWithValue(err)
        }
    }
)
/**
 * @description api to fetch reverse geodata
 * @param latLng
 */
export const getSearchedAddress = createAsyncThunk(
    "addressFlowData/searchAddressPageData",
    async (_arg, { extra, rejectWithValue }) => {
        const { api } = extra
        const latLng = _arg
        try {
            const res = await api.get(`api/v4/reverse_geocoding`, {
                params: latLng,
            })
            return Promise.resolve(res.data)
        } catch (err) {
            return rejectWithValue(err)
        }
    }
)
/**
 * @description Api to remove address data
 * @param address_id
 *
 */
export const removeAddress = createAsyncThunk(
    "addressFlowData/removeAddressData",
    async (_arg, { extra, rejectWithValue }) => {
        const { api } = extra
        const addressData = _arg
        try {
            const res = await api.delete(`api/rbf/user/address?address_id=${addressData?.payload}`)
            if (typeof addressData?.successCallback === "function") {
                addressData?.successCallback()
                return Promise.resolve()
            } else {
                return Promise.resolve(res.data)
            }
        } catch (err) {
            if (typeof addressData?.errorCallback === "function") {
                addressData?.errorCallback(err.error.message)
            }
            return rejectWithValue(err)
        }
    }
)
/**
 *@description api to add address
 */
export const addAddress = createAsyncThunk(
    "addressFlowData/addAddressData",
    async (_arg, { extra, rejectWithValue, getState }) => {
        const { api } = extra
        const addressData = _arg
        const { corporateDetails } = getState().shellReducer
        const { currentCity } = getState().locationsReducer
        const corporate_name = corporateDetails?._source
        try {
            const res = await api.post(`api/rbf/user/address`, {
                ...addressData.payload,
                user_selected_city: currentCity,
                corporate_name,
            })
            if (typeof addressData?.successCallback === "function") {
                addressData?.successCallback(res.data)
                return Promise.resolve()
            } else {
                return Promise.resolve(res.data)
            }
        } catch (err) {
            if (err.error?.is_serviceable === false && typeof addressData?.errorCallback === "function") {
                return rejectWithValue(err.error)
            }
            if (typeof addressData?.errorCallback === "function") {
                addressData?.errorCallback(err.error)
            }
            return rejectWithValue(err)
        }
    }
)
/**
 * @description api to edit/update address
 */
export const editAddress = createAsyncThunk(
    "addressFlowData/editAddressData",
    async (_arg, { extra, rejectWithValue, getState }) => {
        const { api } = extra
        const addressData = _arg
        const { corporateDetails } = getState().shellReducer
        const { currentCity } = getState().locationsReducer
        const corporate_name = corporateDetails?._source
        try {
            const res = await api.put(`api/rbf/user/address?types=${addressData.verticalType}`, {
                ...addressData?.payload,
                user_selected_city: currentCity,
                corporate_name,
            })
            if (typeof addressData?.successCallback === "function") {
                addressData?.successCallback()
                return Promise.resolve()
            } else {
                return Promise.resolve(res.data)
            }
        } catch (err) {
            if (err.error?.is_serviceable === false && typeof addressData?.errorCallback === "function") {
                return rejectWithValue(err.error)
            }
            if (typeof addressData?.errorCallback === "function") {
                addressData?.errorCallback(err.error)
            }
            return rejectWithValue(err)
        }
    }
)
/**
 * @description Fetch pincode data for passed pincode
 */
export const fetchPinCodeDetails = createAsyncThunk(
    "addressFlowData/fetchPincodeData",
    async (_arg, { extra, rejectWithValue }) => {
        const { api } = extra
        const pincode = _arg
        try {
            const res = await api.get(`api/v4/pincode/details?pincode=${pincode}`)
            return Promise.resolve(res.data)
        } catch (err) {
            return rejectWithValue(err)
        }
    }
)
/**
 * @description Fetch serviceability to check if city is serviceable
 */
export const getServiceabilityData = createAsyncThunk(
    "corporateLabsBookingPage/getServicabilityData",
    async (payload, { extra, getState, rejectWithValue }) => {
        try {
            const { corporateDetails } = getState().shellReducer
            const corporate_name = corporateDetails?._source
            const { api } = extra
            const res = await api.post(`/api/rbf/corporate/${corporate_name}/address-serviceability`, payload)
            if (res.data) {
                return Promise.resolve(res.data)
            }
            return rejectWithValue("Something went wrong. Please try again later")
        } catch (error) {
            return rejectWithValue(error?.error?.message || "Something went wrong. Please try again later")
        }
    }
)
export const addressFlowReducer = corporateLabsAddressPageSlice.reducer
export const { setAddressSelectionLoading, setReverseGeoCodeData, setAddressInfo } =
    corporateLabsAddressPageSlice.actions
